var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 194 194",
    style: {
      enableBackground: "new 0 0 194 194"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#006DB6;}\n\t.st2{fill:#92C6C2;}\n\t.st3{fill:#D89E32;}\n\t.st4{fill:#B1B55B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 97,
    cy: 109.5,
    rx: 97,
    ry: 84.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.9,194L194,58.6c0,0-92-75.5-194,0V194H193.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.3,159.3c0,10-8.6,18-19.4,18s-19.4-8-19.4-18c0-10,8.6-18,19.4-18S73.3,149.5,73.3,159.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77.3,169.6 95.9,179.5 114.5,169.6 114.5,149.7 95.9,139.7 77.3,149.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M119.6,150.6c0,0,0-8.5,9.1-8.5h20.1c0,0,9.1,0,9.1,8.5v18.6c0,0,0,8.5-9.1,8.5h-20.1c0,0-9.1,0-9.1-8.5 C119.6,169.2,119.6,150.6,119.6,150.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,120.5l4.6-36.2h0.5l13.3,29.7L66,84.3h0.5l4.6,36.2h-3.1l-3.3-25.9l-11.6,25.9h-0.8l-11.5-26l-3.3,26 H34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.4,120.5l4.6-36.2h0.5l13.3,29.7L108,84.3h0.5l4.6,36.2h-3.1l-3.3-25.9l-11.6,25.9h-0.8l-11.6-26l-3.3,26 H76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.3,90.9l-2.6,2.1c-1.4-2.1-3.1-3.6-5.1-4.7c-2.1-1.1-4.2-1.7-6.6-1.7c-2.6,0-5.1,0.8-7.2,2.1 c-2.2,1.4-4,3.2-5.2,5.6c-1.2,2.3-1.8,5-1.8,7.9c0,4.4,1.4,8.2,4.1,11c2.7,3,6.2,4.4,10.4,4.4c4.6,0,8.5-2,11.5-5.9l2.6,2.1 c-1.6,2.3-3.7,4.1-6.2,5.3c-2.5,1.2-5.2,1.8-8.2,1.8c-5.7,0-10.3-2.1-13.5-6.4c-2.7-3.6-4.1-7.9-4.1-12.9c0-5.3,1.6-9.8,5.1-13.3 c3.4-3.6,7.5-5.4,12.6-5.4c3,0,5.9,0.6,8.3,2C146.6,86.7,148.6,88.5,150.3,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.3,84.3h3.3v36.2h-3.3V84.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmci);
export default __webpack_public_path__ + "static/media/mmci.0565cd4db8c55e7af0ea89c117d283c2.svg";
export { ForwardRef as ReactComponent };